(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialise = (root) => {
    if (!root || root.dataset.wovenReady === 'true') return;
    root.dataset.wovenReady = 'true';

    root.querySelectorAll('[data-woven-wishlist]').forEach((button) => {
      button.addEventListener('click', () => {
        const saved = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!saved));
        button.textContent = saved ? '♡' : '♥';
        button.setAttribute('aria-label', saved ? 'Save to wishlist' : 'Remove from wishlist');
      });
    });

    const hero = root.querySelector('.woven-home-hero');
    const video = hero?.querySelector('video');
    const toggle = hero?.querySelector('[data-video-toggle]');
    const label = toggle?.querySelector('[data-video-label]');

    if (!video || !toggle) return;

    let manuallyPaused = false;

    const updateControl = (paused) => {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      if (label) label.textContent = paused ? 'Play film' : 'Pause film';
    };

    const playVideo = () => {
      if (reducedMotion.matches || manuallyPaused) return;
      const playPromise = video.play();
      if (playPromise) playPromise.then(() => updateControl(false)).catch(() => updateControl(true));
    };

    toggle.addEventListener('click', () => {
      manuallyPaused = !video.paused;
      if (manuallyPaused) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
      updateControl(manuallyPaused);
    });

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) playVideo();
      else video.pause();
    }, { threshold: 0.12 });

    observer.observe(hero);
    updateControl(video.paused);
    playVideo();
  };

  document.querySelectorAll('[data-woven-homepage]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-woven-homepage]')));
})();
